/** Desde cuándo corre el plazo de conservación (#13996), en español. */
export const RETENTION_BASIS_LABELS: Record<string, string> = {
	FORMER_STAFF: "Desde la baja de la persona",
	DOCUMENT_AGE: "Desde que se subió",
	SUPERSEDED: "Desde que hay otro más reciente",
	CANDIDATE_CONTACT: "Candidatos: desde el último contacto",
};
